import React, { ReactNode } from "react";
import styles from "./index.module.scss";
import clsx from "clsx";

export type buttonVariants =
  | "primary"
  | "hollow"
  | "cancel"
  | "gray"
  | "purple";

interface IButton {
  onClick?: () => void;
  content: ReactNode;
  className?: string;
  variant?: buttonVariants;
  icon?: ReactNode;
  disabled?: boolean;
}

export const Button: React.FC<IButton> = ({
  onClick,
  content,
  className = "",
  variant = "primary",
  icon,
  disabled = false,
}) => {
  const varaintBtn = {
    primary: clsx(
      styles.payment_btn__primary,
      disabled && styles.payment_btn__primary_disabled
    ),
    hollow: clsx(
      styles.payment_btn__hollow,
      disabled && styles.payment_btn__disabled
    ),
    cancel: clsx(
      styles.payment_btn__cancel,
      disabled && styles.payment_btn__disabled
    ),
    gray: clsx(
      styles.payment_btn__gray,
      disabled && styles.payment_btn__disabled
    ),
    purple: clsx(
      styles.payment_btn__purple,
      disabled && styles.payment_btn__disabled
    ),
  }[variant];
  return (
    <button
      className={clsx(styles.payment_btn, className, varaintBtn)}
      onClick={onClick}
      type="button"
    >
      {icon && icon}
      <span>{content}</span>
    </button>
  );
};
